export default "__VITE_ASSET__CH2e9t9X__"